import loadScript from 'source/lib/loaders/script';

const TYPE = 'dataLayer';
const initFlag = false;

function loadGtm(settings, authenticated) {
    if (initFlag || !settings) {
        return Promise.resolve(false);
    }
    const gtmCodes = settings[authenticated ? 'AuthenticatedKeys' : 'AnonymousKeys'];
    const { UrlTemplate } = settings;

    if (!Array.isArray(gtmCodes) || gtmCodes.length === 0 || !UrlTemplate) {
        return Promise.resolve(false);
    }

    const promises = [];
    for (let i = 0; i < gtmCodes.length; i += 1) {
        const url = UrlTemplate.replace('%s', gtmCodes[i]);

        window[TYPE] = window[TYPE] || [];
        window[TYPE].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        });
        promises.push(loadScript(url, { noCatch: true }));
    }

    return Promise.all(promises);
}

export default loadGtm;
